<template>
  <ul class="font-size-control list-group w-100"
    v-bind:class="{
      'rounded-0': !multiple,
      'subtitles': !multiple
    }">
    <li v-bind:class="{
        'list-group-item': true,
        'active': multiple && isSentActived(text),
        'text-center': !multiple,
        'text-left': multiple,
        'd-flex': multiple
      }"
      v-for="(text, idx) in texts" :key="idx"
      v-if="multiple || isSentActived(text)">

      <div v-if="hasLeftSideSlot">
        <slot name="leftside" :row="text"></slot>
      </div>

      <!-- en_us -->
      <div class="english mx-auto w-100" v-if="lang.indexOf('en_us') > -1"
        @click="$emit('selectSentId', idx, text.Text)">
        <span class="role-name pl-3" v-if="multiple && text.name" v-html="text.name + ': '"></span>
        <p class="pl-5"
          v-html="isContains(text, highlight)"
          v-if="multiple"></p>

        <p class="subtitle-single"
          v-html="isContains(text, highlight)"
          v-if="!multiple"></p>
      </div>

      <!-- zh_tw -->
      <div class="mx-auto w-100" v-if="lang.indexOf('zh_tw') > -1"
        @click="$emit('selectSentId', idx, text.text)">
        <span class="pl-3"
          v-if="multiple && Array.isArray(text.name_i18N) && text.name_i18N[text.name_i18N.map((e) => { return e.language }).indexOf('Zh')].value !== ''">
          {{ text.name_i18N[text.name_i18N.map((e) => { return e.language }).indexOf('Zh')].value + ': ' }}
        </span>
        <p class="pl-5" v-if="multiple">{{ text.text_i18N[text.text_i18N.map((e) => { return e.language }).indexOf('Zh')].value }}</p>
        <p class="subtitle-single" v-if="!multiple">
          {{ text.text_i18N[text.text_i18N.map((e) => { return e.language }).indexOf('Zh')].value }}
        </p>
      </div>

      <!-- Dictionary -->
      <div class="mx-auto w-100" v-if="dict && text.dicInfos">
        <span class="role-name pl-3" v-if="text.name">{{ text.name + ': ' }}</span>
        <p class="pl-5">
          <span v-for="(word, index) in text.dicInfos" :key="index"
            @click="$emit('word', word.key)">{{ word.word + ' ' }}</span>
        </p>
      </div>

      <div v-if="hasRightSideSlot">
        <slot name="rightside" :row="text"></slot>
      </div>
    </li>
  </ul>
</template>

<script>
  export default {

    name: 'Sentences',

    props: {
      currentTime: {
        type: Number,
        required: false,
        default: 0
      },

      texts: {
        type: Array,
        required: true,
        default: () => {
          return []
        }
      },

      multiple: {
        type: Boolean,
        required: false,
        default: true
      },

      lang: {
        type: Array,
        required: false,
        default: () => {
          return []
        }
      },

      slow: {
        type: Boolean,
        required: false,
        default: false
      },

      highlight: {
        type: Array,
        required: false,
        default: () => {
          return []
        }
      },

      dict: {
        type: Boolean,
        required: false,
        default: false
      }
    },

    data () {
      return {
        sents: []
      }
    },

    computed: {
      hasLeftSideSlot () {
        return !!this.$scopedSlots.leftside
      },

      hasRightSideSlot () {
        return !!this.$scopedSlots.rightside
      }
    },

    created () {
      // this.dict && this.dicInit()
      for (let idx in this.texts) {
        if (this.texts[idx].no === 0) {
          this.texts.splice(idx, 1)
        }
      }
    },

    methods: {
      dicInit () {
        this.sents = this.texts.slice(0)

        for (let idx in this.sents) {
          let index = 0
          let words = []

          if (Array.isArray(this.sents[idx].dicInfos)) {
            for (let j = 0; j < this.sents[idx].dicInfos.length; j++) {
              let start = this.sents[idx].dicInfos[j].begin
              let length = this.sents[idx].dicInfos[j].length

              if (start > index) {
                words.push(this.sents[idx].text.substr(index, (start - index)))
              }

              words.push(this.sents[idx].text.substr(start, length))
              index = start + length
            }
            words.push(this.sents[idx].text.substr(index, this.sents[idx].text.length))

            this.$set(this.sents[idx], 'words', words)
          }
        }
      },

      isSentActived (sent) {
        let begin = (this.slow) ? sent.timeCode_Slow.begin : sent.timeCode_Normal.begin
        let end = (this.slow) ? sent.timeCode_Slow.end : sent.timeCode_Normal.end
        return this.currentTime >= (begin / 1000) && this.currentTime < (end / 1000)
      },

      isContains (text, arr) {
        arr = arr || []
        let sent = text.text

        let mirrorIndex = this.texts.map((e) => { return e.no }).indexOf(text.no)
        let oriText = mirrorIndex > -1 ? this.texts[mirrorIndex].text : sent

        arr.forEach((e) => {
          if (e.highlightType === 'Phrase' &&
            e.locations[0] && text.no === e.locations[0].sentenceNo) {
            let replaceText = oriText.substr(e.locations[0].charBegin, e.locations[0].charEnd - e.locations[0].charBegin)
            sent = sent.replace(new RegExp(replaceText, 'i'), '<span class="highlight">' + replaceText + '</span>')
          } else if (sent.indexOf(e.name) > -1) {
            let re = new RegExp('[^<span(.+?)class=/"highlight/">|^a-zA-Z]' + e.name + '[a-z]*[^</span>]', 'i')
            let replace = re.exec(sent)
            sent = replace ? sent.replace(replace[0], ' <span class="highlight"> ' + replace[0] + ' </span> ') : sent
          }
        })

        return sent
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../assets/style/app.scss";

  p {
    margin-bottom: 0;
  }

  .list-group-item {
    cursor: pointer;
    border-left: 0;
    border-right: 0;
    border-bottom: 1px #ccc solid;
    padding-top: 8px;
    padding-bottom: 8px;
    color: $dark;

    .role-name {
      color: $role-name;
    }

    &:first-child {
      border-top: 0;
    }

    &:last-child {
      border-bottom: 0;
    }

    &:hover {
      background-color: $normal;
      border-color: $normal;
      color: #fff;
    }

    &.active {
      background-color: $normal;
      border-color: $normal;
      color: #fff;

      .role-name {
        color: #fff;
      }
    }

  }

  .subtitles {
    min-height: 64px;
    background-color: $dark;
    color: #fff;

    .list-group-item {
      background-color: $dark;
      color: #fff;
    }
  }

  .subtitle-single {
    .highlight {
      color: $vocab-color;
    }
  }

  .english {
    font-family: arial;
  }
</style>



// WEBPACK FOOTER //
// Sentences.vue?3c22d1c8